export const jet5 = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber.',
    'Triple Rotating Structure and Spoiler Exterior Design',
    'Invisible Leveraged Balancing Structure',
    'Patented Multi-functional Mounting Base & Adapters.',
  ],
  'material': [
    'Rubber: Premium Nature Rubber.',
    'Steel: SGCC, Electrostatic Powder Coating.',
    'Rivet: Steel Rivet',
    'Plastic: Spacer: POM, Adapter: PA+GF30%, Spoiler: PC+ABS',
    'Stainless Steel Backing: SUS304ES',
  ],
  'featureIcons': ["11", "02", "03", "04", "07", "10"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "14", "mm": "350", "claw": "4", "width": "6", "thickness": "0.8" },
    { "inch": "15", "mm": "375", "claw": "4", "width": "6", "thickness": "0.8" },
    { "inch": "16", "mm": "400", "claw": "4", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "425", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "450", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "475", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "500", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "21", "mm": "525", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "22", "mm": "550", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "8", "thickness": "0.8" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1" }
  ],
  'adapters': [
    "b1", "b6", "bl-2a", "cl+cl-r", "m3", "m4", "m5", "ml", "ph-3", "pl", "pt-3", "pt6", "pt-r", "tl-2", "tl4a", "tlc", "a3"
  ]
}